import React,{useEffect,useState} from "react";

import {
    Card,
    Space,
    Avatar,
    Typography,
    Row,
    Col,
    Divider,
    Spin
} from "antd";

import {
    ApartmentOutlined,
    BookOutlined,
    ClusterOutlined
} from "@ant-design/icons";

import { motion } from "framer-motion";

import api from "../../api/api";


const {Title,Text}=Typography;


const AcademicCount=({theme})=>{

    const [loading,setLoading]=useState(false);

    const [counts,setCounts]=useState({
        total_grade_classes:0,
        total_subjects:0,
        total_divisions:0
    });


    useEffect(()=>{

        fetchCounts();


        const updateCounts=()=>{

            fetchCounts();

        };


        window.addEventListener(
            "academicCountUpdated",
            updateCounts
        );


        return()=>{

            window.removeEventListener(
                "academicCountUpdated",
                updateCounts
            );

        };


    },[]);



    const fetchCounts=async()=>{

        try{

            setLoading(true);

            const res=await api.get(
                "/grade-class-subject-division-count/"
            );


            setCounts(res.data);


        }catch(error){

            console.log(error);

        }finally{

            setLoading(false);

        }

    };



    return(

    <motion.div
        whileHover={{y:-4}}
        transition={{duration:.25}}
    >

        <Card

            bodyStyle={{
                padding:18
            }}

            style={{
                background:theme.card,
                borderRadius:16,
                border:`1px solid ${theme.border}`,
                height:"100%"
            }}

        >


        {
            loading ?

            <div
                style={{
                    display:"flex",
                    justifyContent:"center",
                    padding:30
                }}
            >

                <Spin/>

            </div>


            :


            <>


            <Space align="center">

                <Avatar
                    size={56}
                    style={{
                        background:"#5A0B16",
                        fontSize:24
                    }}
                >

                    <ClusterOutlined/>

                </Avatar>



                <div>

                    <Text
                        style={{
                            color:theme.secondary
                        }}
                    >
                        Grade Classes
                    </Text>


                    <Title
                        level={2}
                        style={{
                            margin:0,
                            color:theme.text
                        }}
                    >

                        {counts.total_grade_classes}

                    </Title>


                    <Text
                        style={{
                            color:"#999"
                        }}
                    >
                        Total grade classes available
                    </Text>


                </div>


            </Space>



            <Divider
                style={{
                    margin:"16px 0"
                }}
            />



            <Row gutter={18}>


                <Col span={12}>

                    <Space>


                        <Avatar
                            style={{
                                background:"#1677ff"
                            }}
                        >

                            <BookOutlined/>

                        </Avatar>


                        <div>

                            <Text type="secondary">
                                Subjects
                            </Text>


                            <Title
                                level={4}
                                style={{
                                    margin:0,
                                    color:theme.text
                                }}
                            >

                                {counts.total_subjects}

                            </Title>


                        </div>


                    </Space>


                </Col>



                <Col span={12}>


                    <Space>


                        <Avatar
                            style={{
                                background:"#8B4513"
                            }}
                        >

                            <ApartmentOutlined/>

                        </Avatar>



                        <div>

                            <Text type="secondary">
                                Divisions
                            </Text>


                            <Title
                                level={4}
                                style={{
                                    margin:0,
                                    color:theme.text
                                }}
                            >

                                {counts.total_divisions}

                            </Title>


                        </div>



                    </Space>


                </Col>


            </Row>


            </>

        }


        </Card>


    </motion.div>

    );


};


export default AcademicCount;